import React, { useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import { IoPhonePortraitOutline } from "react-icons/io5";
import EnquiryForm from "./EnuiryNowForm";

function InternationalSim() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    destination: "",
    plan: "",
    price: "",
    name: "",
    phone: "",
    email: "",
  });

  const handleEnquiryClick = (destination, plan, price) => {
    setFormData({ ...formData, destination, plan, price });
    setIsFormOpen(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Enquiry Submitted:", formData);
    alert("Enquiry Sent!");
    setIsFormOpen(false);
  };

  return (
    <>
      {/* ENQUIRY POPUP */}
      <EnquiryForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
      />

      <div className="pt-20 flex flex-col items-center px-4">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center max-w-lg leading-snug">
          BUY SIM + FOREX CARD IN JUST 5 MINUTES
        </h2>

        <div className="mt-8 w-full max-w-2xl bg-white shadow-xl rounded-2xl p-6 border border-gray-200">
          <p className="text-lg font-semibold text-gray-700 mb-4">
            Manage your Trip
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {/* Destination */}
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-600">
                Destination
              </label>
              <select className="w-full px-3 py-2 border rounded-lg bg-gray-50 text-gray-700">
                <option>🇦🇪 UAE</option>
                <option>🇹🇭 Thailand</option>
                <option>🇸🇬 Singapore</option>
                <option>🇲🇾 Malaysia</option>
                <option>🇮🇩 Bali / Indonesia</option>
                <option>🇻🇳 Vietnam</option>
              </select>
            </div>

            {/* Nights */}
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-600">
                Number of Nights
              </label>
              <input
                type="number"
                className="w-full px-3 py-2 border rounded-lg bg-gray-50"
              />
            </div>

            {/* Passengers */}
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-600">
                Number of Passengers
              </label>
              <input
                type="number"
                className="w-full px-3 py-2 border rounded-lg bg-gray-50"
              />
            </div>
          </div>
        </div>
      </div>

      {/* SIM PLANS */}
      <div className="mt-14 px-6">
        <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
          Individual SIM Plans
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Lite Plan */}
          <PlanCard
            title="SIM Lite Plan"
            price="599"
            plan="1 GB International SIM"
            icon={<IoPhonePortraitOutline size={50} />}
            onClick={() =>
              handleEnquiryClick("International SIM", "SIM Lite Plan", "₹599")
            }
          />

          <PlanCard
            title="SIM Value Plan"
            price="1199"
            plan="5 GB International SIM"
            icon={<IoPhonePortraitOutline size={50} />}
            onClick={() =>
              handleEnquiryClick("International SIM", "SIM Value Plan", "₹1199")
            }
          />

          <PlanCard
            title="SIM Premium Plan"
            price="1999"
            plan="15 GB International SIM"
            icon={<IoPhonePortraitOutline size={50} />}
            onClick={() =>
              handleEnquiryClick(
                "International SIM",
                "SIM Premium Plan",
                "₹1999"
              )
            }
          />
        </div>
      </div>

      {/* FOREX CARD */}
      <div className="mt-20 mx-6">
        <h2 className="text-center text-3xl font-bold text-gray-800 py-4">
          Forex Card
        </h2>

        <div className="max-w-sm mx-auto">
          <PlanCard
            title="Forex Card"
            price="500"
            plan="Forex Card"
            icon={<FaDollarSign size={50} />}
            onClick={() =>
              handleEnquiryClick("Forex", "Forex Card", "₹500")
            }
          />
        </div>
      </div>
    </>
  );
}

const PlanCard = ({ title, price, plan, icon, onClick }) => (
  <div className="flex flex-col items-center text-center bg-white shadow-md hover:shadow-xl transition-shadow border border-gray-200 rounded-xl p-6 gap-4">
    <div className="text-blue-600 text-4xl mb-3">{icon}</div>
    <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
    <h3 className="text-2xl font-semibold text-green-600 mt-1">
      {plan} ₹{price}
    </h3>

    <ul className="mt-4 text-gray-600 text-lg space-y-2">
      <li>✔ Instant activation on arrival</li>
      <li>✔ 24/7 customer support</li>
      <li>✔ No roaming charges</li>
      <li>✔ Easy online recharge</li>
    </ul>

    <button
      onClick={onClick}
      className="mt-5 px-5 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition"
    >
      Enquiry Now
    </button>
  </div>
);

export default InternationalSim;
